<template>
  <div class="radio-button">
    <input
      :id="id"
      type="radio"
      class="radio-button__input"
      :checked="checked"
      :name="name"
      :value="value"
      @change="handleChange"
      @blur="emitBlurEvent"
    >
    <label
      class="radio-button__label"
      :for="id"
    >
      <!-- @slot Label contents, defaults to value if no slot data is provided -->
      <slot>{{ value }}</slot>
    </label>
    <text-input
      v-if="isOther"
      :id="`${id}-otherInputValue`"
      v-model="otherInputValue"
      input-type="text"
      @input="handleOtherInput"
    />
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import TextInput from '@/components/Inputs/TextInput.vue';

export default {
  name: 'RadioButton',
  components: {
    TextInput,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
    otherValue: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      required: true,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    isOther: {
      type: Boolean,
      default: false,
    },
    returnsShorterPayload: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      otherInputValue: this.otherValue,
      isChecked: this.checked,
    };
  },
  methods: {
    handleChange() {
      this.isChecked = !this.isChecked;
      this.emitEvent();
    },
    // eslint-disable-next-line func-names
    handleOtherInput: debounce(function (value) {
      this.otherInputValue = value;
      this.emitEvent();
    }, 500),
    emitEvent() {
      if (this.returnsShorterPayload) {
        this.$emit('input', this.value);
        return;
      }
      const payload = {
        checked: this.isChecked,
        value: this.value,
        otherValue: this.otherInputValue,
        name: this.name,
        id: this.id,
      };
      this.$emit('input', payload);
    },
    emitBlurEvent() {
      this.$emit('blur');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_radio-button';
</style>

<docs>
</docs>
